import {BaseService} from "./base.service";

class InvoiceQuotersService extends BaseService {

    constructor() {
        super('api/invoice-quoters')
    }

}

export const invoiceQuotersService = new InvoiceQuotersService();
